import { Component, EventEmitter, Input, OnDestroy, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Address, AddressHelper } from "@app/address/model/address";
import { AddressDispatchers } from "@app/address/store";
import { EntityService } from "@app/entity/services/entity.service";
import { Action } from "@ngrx/store";
import { BehaviorSubject, Observable, Subject, takeUntil, tap } from "rxjs";

@Component({
    selector: "address-container",
    templateUrl: "./address-dialog-container.component.html",
    styleUrls: ["./address-dialog-container.component.scss"],
})
export class AddressContainerComponent implements OnDestroy {
    @Input() address$: BehaviorSubject<Address>;
    @Input() communities$: Observable<any[] | Error>;
    @Input() builders$: Observable<any[] | Error>;
    @Input() buildingTypes$: Observable<any[] | Error>;
    @Output() emitter: EventEmitter<Action> = new EventEmitter<Action>();
    @Input() includeLookup: boolean;
    @Input() addressType: "billingAddress" | "shippingAddress" | "projectAddress";
    unsubscribe$ = new Subject();

    addressForm: FormGroup = this.formBuilder.group({
        id: [],
        address: ["", Validators.required],
        address2: [],
        city: ["", Validators.required],
        state: [""],
        country: ["", Validators.required],
        zipcode: [""],
        coordinates: [],
        timezonename: [],
        timezoneid: [],
        typeid: [""],
        area: [""],
        builderid: [],
        communityid: [],
        gateaccesscode: [""],
        crossstreet: ["", Validators.maxLength(100)],
        directions: ["", Validators.maxLength(500)],
    });
    submitAttempted = false;
    isLookupComplete = false;

    constructor(
        private readonly addressDispatchers: AddressDispatchers,
        private readonly formBuilder: FormBuilder,
        private readonly entityService: EntityService
    ) {}

    ngOnDestroy(): void {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }

    saveAddress(address: BehaviorSubject<Address>) {
        this.entityService
            .selectCurrentEntity$()
            .pipe(
                takeUntil(this.unsubscribe$),
                tap(entity => {
                    this.addressForm.patchValue(address.value);
                    this.submitAttempted = true;
                    this.addressDispatchers.upsert(this.addressForm, this.emitter, entity?.id, address.value, this.addressType);
                })
            )
            .subscribe();
    }

    isComplete(address: Address) {
        return AddressHelper.isValid(address);
    }

    cancel() {
        this.emitter.emit();
    }
    updateLookupStatus($event: boolean) {
        this.isLookupComplete = this.includeLookup ? $event : true;
    }
}
